import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SurveyManagementEffects } from './state/survey-management.effects';
import { surveyManagementFeature } from './state/survey-management.feature';

export const SURVEY_MANAGEMENT_STORE_PROVIDERS = {
  feature: provideState(surveyManagementFeature),
  effects: provideEffects(SurveyManagementEffects),
};
